module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"filters":"Filtrer","sort":"Trier"},"en":{"filters":"Filter","sort":"Sort"},"de":{"filters":"Filtern","sort":"Sortieren"},"es":{"filters":"Filtrar","sort":"Ordenar"},"it":{"filters":"Filtra","sort":"Ordina"},"nl":{"filters":"Filter","sort":"Sorteren"},"pt":{"filters":"Filtrar","sort":"Ordenar"}}')
  delete Component.options._Ctor
}
